import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { ArrowIcon } from '~/icons';

export const StyledArrowIcon = styled(ArrowIcon)<{ isOpen: boolean }>(
  ({ isOpen }) => `
  margin-left: 12px;
  transition: all 0.2s;
  transform: rotate(${isOpen ? '-180' : '0'}deg);
`,
);

export const Container = styled.div`
  position: relative;
`;

export const SelectButton = styled.button<{
  disabled?: boolean;
  isOpen: boolean;
}>`
  display: flex;
  max-width: 200px;
  background: transparent;
  border: none;
  transition: all 0.2s ease;
`;

export const SelectText = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.text['main-900']};
  text-align: left;
  flex: 1;
  cursor: pointer;
`;

export const SelectIcon = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  transition: transform 0.2s ease;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    color: ${colors.Blue700};
  }
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${colors.White};
  z-index: 1000;
  overflow-y: auto;
  margin-top: 4px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  max-height: 280px;
  width: 173px;
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid ${colors.text['disabled-300']};
  border-right: 1px solid ${colors.text['disabled-300']};
  border-left: 1px solid ${colors.text['disabled-300']};
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE e Edge */
`;

export const DropdownItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  position: relative;

  color: ${({ isSelected }) => (isSelected ? colors.text['primary-base'] : colors.text['main-900'])};
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  justify-content: space-between;
  border-top: 1px solid ${colors.text['disabled-300']};

  &:hover {
    color: ${colors.text['primary-base']};
  }
  
  &:first-child {
    border-radius: 8px 8px 0 0;
    border-top: none;
  }
  
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;
